import { SHOW_VISITS_MESSAGE, ON_SHOW_VISITS_LOADER, ON_HIDE_VISITS_LOADER, HIDE_MESSAGE } from '../../../constants/ActionTypes';

const INIT_STATE = {
    loader: false,
    alertMessage: '',
    showMessage: false,
    visits: []
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case ON_SHOW_VISITS_LOADER: {
            return {
                ...state,
                loader: true
            }
        }
        case HIDE_MESSAGE: {
            return {
                ...state,
                alertMessage: '',
                showMessage: false,
                loader: false
            }
        }

        default:
            return state;
    }
}